export default __webpack_public_path__ + "static/media/home.0d61b2a4.svg";